import {connect} from 'react-redux';

import {getIsUserGlobalAdmin} from '../../../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {getHasP4MultiView} from '../../../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {ViewerPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getIsApplicationsLoading} from '../../../../store/data/applications/applicationsSelectors';
import {getSidepanelMultiViewDetails} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {updateSortedFrameIdsAction} from '../../../../store/data/preferences/preferencesActions';
import {getSortedVisiblePanelFrames} from '../../../../store/stateless/sidePanelFrameSelectors';
import {getIsStartGuideIncomplete} from '../../../../store/stateless/startGuideSelectors';
import {SidePanelSwitcher} from './sidePanelSwitcher';

interface SidePanelSwitcherContainerProps {
  panelId: ViewerPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SidePanelSwitcherContainerProps>()(() => ({
  visibleFrames: getSortedVisiblePanelFrames,
  isStartGuideIncomplete: getIsStartGuideIncomplete,
  isUserGlobalAdmin: getIsUserGlobalAdmin,
  hasP4MultiView: getHasP4MultiView,
  multiViewDetails: getSidepanelMultiViewDetails,
  isApplicationsLoading: getIsApplicationsLoading,
}));

const dispatchProps = {
  onFrameIdsSort: updateSortedFrameIdsAction,
};

export const SidePanelSwitcherContainer = connect(mapStateToProps, dispatchProps)(SidePanelSwitcher);
